import type {CompanyReport} from '@/types'

const initialState: CompanyReport = {
  isLoading: false,
  list: [],
  error: '',
  dataLoader: false,
  decisionTreeData: {},
  dataError: '',
}

export default (state: CompanyReport = initialState, action): CompanyReport => {
  const {type, payload} = action

  switch (type) {
    case 'GET_COMPANY_TREE_LIST':
      return {
        ...state,
        isLoading: true,
        list: [],
        error: '',
      }
    case 'GET_COMPANY_TREE_LIST_SUCCESS':
      return {
        ...state,
        isLoading: false,
        list: !(payload.messages || payload.message) ? payload.GUIDList : [],
        error: payload.messages ? {messages: payload.messages}
          : (payload.message ? {message: payload.message} : ''),
      }
    case 'GET_COMPANY_TREE_LIST_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: payload.data || {message: 'Service is unavailable, please try again later.'}, // TODO: remove this when api fixes
      }
    case 'GET_DECISION_TREE_DATA':
      return {
        ...state,
        dataLoader: true,
        decisionTreeData: {},
        dataError: '',
      }
    case 'GET_DECISION_TREE_DATA_SUCCESS':
      return {
        ...state,
        dataLoader: false,
        decisionTreeData: !(payload.messages || payload.message) ? payload : {},
        dataError: payload.messages ? {messages: payload.messages}
          : (payload.message ? {message: payload.message} : ''),
      }
    case 'GET_DECISION_TREE_DATA_FAILURE':
      return {
        ...state,
        decisionTreeData: {},
        dataLoader: false,
        dataError: payload.data || {message: 'Service is unavailable, please try again later.'}, // TODO: remove this when api fixes
      }
    case 'LOG_OUT':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/decision-tree/reducer.js